<template>
    <div class="locations js">
        <!-- <div class="locations-section">
            <div id="breadcrumbs">
                <nav class="breadcrumbs">
                <span class="breadcrumbs-item">
                    <a href="/">
                    <span>{{ $t('new.home') }}</span>
                    </a>
                </span>
                <span class="breadcrumb-divider" aria-hidden="true">/</span>
                </nav>
            </div>
        </div> -->
        <div class="map-wrapper">
            <div class="map--image">
                <!-- Google Maps 组件 -->
                <GmapMap
                    :center="center"
                    :zoom="zoom"
                    style="width: 100%; height: 100%"
                    :options="{ disableDefaultUI: true,styles: mapStyles }"
                >
                    <!-- 地图标记点 -->
                    <GmapMarker
                        v-for="(marker, index) in locationsList[0]?.value[0]?.content"
                        :key="index"
                        :position="marker.latitude_and_longitude"
                        :icon="{
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        }"
                        @click="onMarkerClick(marker)"
                    />
                    <!-- 用户当前位置标记 -->
                    <GmapMarker
                        v-if="userLocation"
                        :position="userLocation"
                        :icon="userIcon"
                        />

                        <!-- 信息窗口 -->
                        <GmapInfoWindow
                        v-if="selectedMarker"
                        :options="{ maxWidth: '500',width:'500' }"
                        :position="selectedMarker.latitude_and_longitude"
                        @closeclick="onInfoWindowClose"
                        :visible="isInfoWindowVisible"
                        >
                        <div class="info-window-content">
                            <div class="info-window-avater">
                                <img :src="selectedMarker.icon" alt="">
                            </div>
                            <div class="info-window-titleCont">
                                <h5>{{ selectedMarker.name }}</h5>
                                <span>{{ selectedMarker.url }}</span>
                            </div>
                            <div class="info-window-body">
                                <div class="info-window-footer">
                                    <button @click="navigateToLocation(selectedMarker)">
                                    <i class="el-icon-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </GmapInfoWindow>
                </GmapMap>
            </div>
            <div class="map-btn-box animated fadeIn" data-animate data-animate-order="1">
                <div class="map-content-box-inner" v-if="locationsList && locationsList[0]?.value[0]?.content">
                    <div class="sitewide--title-wrapper">
                        <h2 class="homepage-sections--title" data-animate data-animate-order="2">{{ locationsList[0]?.value[0]?.title }}</h2>
                    </div>
                    <div class="map-btn-content" data-animate data-animate-order="3">
                        <!-- <h5 v-for="(item,index) in locationsList[0]?.value[0]?.content" :key="index">
                            <a :href="item.url">{{item.name}}</a>
                        </h5> -->
                        <h5>
                            <strong>{{ $t('new.localTitle') }}</strong>
                        </h5>
                        <h5 class="h5text">{{ $t('new.localText') }}</h5>
                        <h5>
                            <strong>{{ $t('new.localTitle1') }}</strong>
                        </h5>
                        <h5>{{ $t('new.localText1') }}</h5>
                        <h5>{{ $t('new.localText2') }}</h5>
                        <h5>{{ $t('new.localText3') }}</h5>
                        <h5>{{ $t('new.localText4') }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { getDataList } from '@/api/komo'
    export default {
        name: 'locations',
        data() {
            return {
                locationsList: [],
                center: { lat: 1.3521, lng: 103.8198 }, // 新加坡坐标
                zoom: 6,
                selectedMarker: null,
                userLocation: null,
                isInfoWindowVisible: true,
                userIcon: {
                    url: require('@/assets/home/dqdw.png'),
                    scaledSize: { width: 88, height: 88 }
                },
                markers: [
                    {
                        name: '新加坡',
                        position: { lat: 1.3521, lng: 103.8198 },
                        icon: {
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        },
                        description: '新加坡共和国'
                    },
                    {
                        name: '马来西亚',
                        position: { lat: 3.1497, lng: 101.6942 },
                        icon: {
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        },
                        description: '马来西亚联邦'
                    },
                    {
                        name: '泰国',
                        position: { lat: 13.7563, lng: 100.5018 },
                        icon: {
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        },
                        description: '泰王国'
                    },
                    {
                        name: '印度尼西亚',
                        position: { lat: -6.2088, lng: 106.8456 },
                        icon: {
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        },
                        description: '印度尼西亚共和国'
                    },
                    {
                        name: '巴西',
                        position: { lat: -53.8496, lng: -8.8856 },
                        icon: {
                            url: require('@/assets/home/dw.png'),
                            scaledSize: { width: 50, height: 50 }
                        },
                        description: '巴西'
                    }
                ],
                // 添加自定义地图样式 - 白色和淡紫色主题
                mapStyles: [
                    {
                        "featureType": "all",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f8f9fa"  // 淡紫色背景
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#6c757d"  // 深紫色文字
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"  // 文字描边白色
                            },
                            {
                                "weight": 0.5
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "geometry.stroke",
                        "stylers": [
                        {
                            "color": "#e9ecef"  // 国家边界线
                        },
                        {
                            "weight": 0.5
                        }
                        ]
                    },
                    {
                        "featureType": "administrative.country",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#495057"  // 国家标签深紫色
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f8f9fa"  // 地景淡紫色
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e0e9fc"  // 水域
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#495057"  // 水域标签紫色
                            }
                        ]
                    }
                ]
            }
        },
        async created() {
            await this.initData();
        },
        methods: {
            async initData () { 
                const locationsDatalist = await getDataList(localStorage.getItem('pageId'));
                this.locationsList = locationsDatalist.data.list;
                this.locationsList[0]?.value[0]?.content.forEach(item => { 
                    try {
                    if (item.latitude_and_longitude) {
                        const coords = item.latitude_and_longitude.split(',')
                        if (coords.length === 2) {
                        item.latitude_and_longitude = {
                            lat: parseFloat(coords[0].trim()),
                            lng: parseFloat(coords[1].trim())
                        }
                        }
                    }
                    } catch (e) {
                        console.error('经纬度转换错误:', e)
                        item.coordinates = null
                    }
                })
                this.$nextTick(() => {
                    this.initAnimations();
                })
            },
            // 获取用户当前位置
            getCurrentPosition() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        
                        this.userLocation = { lat, lng };
                        this.center = { lat, lng };
                        // 屏幕小于768时zoom为1，否则为2
                        this.zoom = window.innerWidth < 768 ? 1.5 : 2;
                        
                        console.log('用户位置:', lat, lng,this.zoom);
                    },
                    (error) => {
                        console.error('获取位置失败:', error);
                        alert('无法获取您的位置，请检查浏览器设置');
                    },
                    {
                        enableHighAccuracy: true, // 高精度
                        timeout: 10000, // 超时时间
                        maximumAge: 0 // 不缓存位置
                    }
                    );
                } else {
                    alert('您的浏览器不支持地理位置功能');
                }
            },
            // 点击标记点事件
            onMarkerClick (marker) {
                console.log('点击',marker)
                this.selectedMarker = marker;
                this.isInfoWindowVisible = true;
            },
            onInfoWindowClose () {
                console.log('关闭')
                this.isInfoWindowVisible = false;
                this.selectedMarker = null; // 清除选中的标记
            },
            navigateToLocation(marker) {
                // this.center = marker.position;
                // this.zoom = 12;
                console.log('marker', marker)
                window.open(marker.url, '_blank', 'noopener,noreferrer');
                this.isInfoWindowVisible = false;
                this.selectedMarker = null; // 同时清除选中状态
            },
            initAnimations() {
                // 获取所有带 data-animate 属性的元素
                const animateElements = document.querySelectorAll('[data-animate]');
                
                animateElements.forEach(element => {
                    const order = element.getAttribute('data-animate-order') || 0;
                    // 添加延时，按顺序播放动画
                    setTimeout(() => {
                    element.classList.add('animate-trigger');
                    }, order * 300); // 300ms 间隔
                });
            }
        },
        mounted () {
            // 页面加载时尝试获取用户位置
            this.getCurrentPosition();
        }
    }
</script>
<style scoped lang="scss">
.locations {
    padding: var(--nav-max-height) 0 0;
    display: block;
    .locations-section { 
        width: 100%;
        #breadcrumbs{
            margin: 0;
            padding-top: 15px;
            padding-bottom: 15px;
            padding-left: 60px;
            padding-right: 60px;
            .breadcrumbs{ 
                font-size: 0;
                .breadcrumbs-item{
                    margin-right: 10px;
                    display: inline-block;
                    font-size: 12px;
                    a{
                    color: var(--font-color);
                    span{
                        display: inline-block;
                        padding-bottom: 0;
                        font-family: var(--label-font-stack);
                        font-weight: var(--label-font-weight);
                        font-style: var(--label-font-style);
                        text-transform: var(--label-font-case);
                        letter-spacing: var(--label-spacing);
                    }
                }
            }
            .breadcrumb-divider{
                font-size: 12px;
            }
        }
      }
    }
}
.map-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    align-items: center;
    position: relative;
    min-height: 750px; 
}
.map--image,.map--placeholder-container{
    position: relative;
    grid-column: 1/2;
    grid-row: 1/2;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.map-wrapper1,.map--fallback-wrap{
    display: block;
    width: 100%;
    height: 100%;
}
.map--fallback-wrap{
    overflow: hidden;
}
.map--placeholder-container{

}
/* 地图文字 */
.map-btn-box {
    position: relative;
    grid-column: 1/2;
    grid-row: 1/2;
    width: fit-content;
    z-index: 2;
    transform: none;
    color: #422b20;
    background: #e8e2d9
}

.map-content-box-inner {
    text-align: center;
    padding: 30px;
    word-break: break-word;
}

.homepage-sections--title {
    font-size: var(--h2-size);
    font-family: var(--header-font-stack);
}
.map-btn-content h5{
    font-size: var(--h5-size);
    font-family: var(--header-font-stack);
    margin-top: 1em;
    margin-bottom: 0;
    color: #422b20;
}
.map-btn-content h5:first-child{
    margin-top: 0em;
}
.map-btn-content h5 a{
    text-decoration: none;
    color: #422b20;
}
.map-btn-content .h5text{
    margin: 0;
}
.info-window-content {
  padding: 10px;
  font-size: 14px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  gap: 2%;
  align-items: center;
}
.info-window-avater{
  width: 80px;
  height: 80px;
}
.info-window-avater img{ 
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.info-window-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.info-window-body {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.info-window-footer {
  text-align: right;
}

.info-window-footer button {
  padding: 0.2vw 0.3vw;
  background-color: #1e1e1e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.5vw;
}

.info-window-footer button:hover {
  background-color: #000;
}
@media only screen and (min-width: 768px) {
    .breadcrumbs a{
      background-color: transparent !important;
      background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
      background-repeat: no-repeat;
      background-position: left bottom, left bottom;
      background-size: 0 1px, 100% 1px;
      transition-property: background-size;
      transition-timing-function: ease;
      transition-duration: .25s;
    }
    .breadcrumbs a:hover{
      background-position: left bottom, left bottom;
      background-size: 100% 1px, 100% 1px;
    }
    .map-btn-box{
        width: 30%;
        margin: 30px 60px;
    }
}
@media (max-width: 1115px){
  .locations{
    padding: var(--nav-1115-height) 0 0;
  }
}
@media (max-width: 990px){
  .locations{
    padding: var(--nav-990-height) 0 0;
  }
}
@media screen and (max-width: 768px){ 
    .map-wrapper{
        display: flex;
        flex-direction: column-reverse;
    }
    .map--image{
        height: 70vh;
    }
    .map-btn-box{
        width: 100%;
    }
}
</style>